module.exports = __webpack_public_path__ + "static/media/support_ticket_user.a0ad4131.png";